var _path, _path2, _line, _line2, _rect, _path3, _rect2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeyondDataS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 119,
    viewBox: "0 0 143 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2019 23.5604C54.115 22.937 60.9492 19.8812 71.4932 13C82.0371 19.8812 88.8713 22.937 104.784 23.5604V60.029C104.784 70.884 101.934 81.9174 94.3418 89.6545C88.179 95.9348 81.4931 100.329 71.4932 105.659C61.4932 100.329 54.8073 95.9348 48.6445 89.6545C41.0521 81.9174 38.2019 70.884 38.2019 60.029V23.5604Z",
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2393 38.052C74.0258 38.052 76.7001 39.1704 78.6729 41.1633C80.6456 43.1564 81.7548 45.8611 81.7549 48.6829V53.5139H60.7236V48.6829C60.7237 45.861 61.8337 43.1564 63.8066 41.1633C65.7793 39.1705 68.4528 38.0521 71.2393 38.052Z",
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.6965,
    y1: 53.0099,
    x2: 38.2029,
    y2: 53.0099,
    stroke: "#101010",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104.786,
    y1: 53.0099,
    x2: 125.292,
    y2: 53.0099,
    stroke: "#101010",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 45.1587,
    width: 17.1963,
    height: 17.1963,
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.529 58.7482L141.154 58.965L133.261 63.5226L132.886 63.7384L132.511 63.5226L124.618 58.965L124.243 58.7482V48.7687L124.618 48.5519L132.511 43.9952L132.886 43.7784L133.261 43.9952L141.154 48.5519L141.529 48.7687V58.7482Z",
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1798,
    y: 54.0054,
    width: 27.8672,
    height: 23.5634,
    fill: "#EFE4D2",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4941 62.1021C73.5068 62.1022 75.1736 63.7864 75.1738 65.9087C75.1738 68.0312 73.5069 69.7162 71.4941 69.7163C69.4813 69.7163 67.8135 68.0313 67.8135 65.9087C67.8137 63.7863 69.4814 62.1021 71.4941 62.1021Z",
    fill: "#FD4C00",
    stroke: "#101010",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondDataS);
export default __webpack_public_path__ + "static/media/beyond-data-s.6657d6c0d0baaf020a8d8fae38f643e8.svg";
export { ForwardRef as ReactComponent };